// Foundation
import 'what-input'
import 'foundation-sites'

import 'picturefill'

// Do picturefill I guess?
picturefill()

// finish setting up globals for jquery and foundation
$(document).foundation()

$('.bylaw-search__input').keyup(function() {
    // Retrieve the input field text and reset the count to zero
    var filter = $(this).val()
    var count = 0
    var $bylawAccordion = $('.bylaw-index.accordion')
    var $noResults = $('.callout--no-search-results')
  
    $('.bylaw-index-province .accordion-content').each(function() {
        var provinceCount = 0
        var $province = $(this)
        var $provinceWrapper = $province.parent()

        $province.find('.bylaw-region-link').each(function() {
            var $regionLink = $(this)

            if ($regionLink.text().search(new RegExp(filter, 'i')) < 0) {
                $regionLink.hide()
            } else {
                $regionLink.show()
                provinceCount++
            }
        })
        
        if (provinceCount === 0) {
            $provinceWrapper.hide();
            $bylawAccordion.foundation('up', $province);
        } else {
            $provinceWrapper.show();
            $bylawAccordion.foundation('down', $province);
        }

        count += provinceCount
    })
  
    if (count === 0) {
        $noResults.show()
    } else {
        $noResults.hide()
    }
})
  